import { useEffect, useRef } from "react";
import { useState } from "react";
import { Page,
    // Logo,
    Area,
    Text,
    ButtonArea,
    ToggleButtonArea,
    BigButtonArea,
    ToggleButton,
    Button,
    Clip,
    Overlay,
    ButtonLink,
    LoadLogo,
    LoadContainer,
    Lace,
    ScrollText,
    Logo
} from "./styles";

const FullPageLoader = () => {
    return (
        <LoadContainer>
            <LoadLogo />
        </LoadContainer>
    )
}

const Home = () => {
    // const [loading, setLoading] = useState(false);
    // useEffect(() => {
    //     setTimeout(() => { setLoading(false) }, 4000)
    // }, [])

    return (
    <Page>
        {/* { loading && <FullPageLoader /> } */}
        <Overlay />
        <Area>
        <Logo />
            <Text />
            <ButtonArea>
                <BigButtonArea>
                    <ButtonLink to="/events/xxxperience">Garanta seu Ingresso</ButtonLink>
                    <Button>
                    <a style={{color: "rgb(242, 229, 213)", width: "100%", height: "100%", textDecoration: "none", display: "flex", justifyContent: "center", alignItems: "center"}} href="https://wa.me/+5511995093002">
                        {/* <Clip active={true}>
                            <span> */}
                                Entre em Contato
                            {/* </span>
                        </Clip> */}
                    </a>
                    </Button>
                </BigButtonArea>
            </ButtonArea>
            {/* <Lace>
                <ScrollText>
                    <div>anos 2000</div>
                </ScrollText>
                <ScrollText>
                    <div>anos 2000</div>
                </ScrollText>
                <ScrollText>
                    <div>anos 2000</div>
                </ScrollText>
            </Lace> */}
        </Area>
    </Page>
    )
}

export default Home;